module.exports = __webpack_public_path__ + "s4.no2.1a8220ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s4.no2.jpg
// module id = +66/
// module chunks = 0